import {memo, useEffect, useRef, useState} from "react";
import axios from "axios";
import {Button, Toast} from "antd-mobile";
import {useLocation} from "react-router-dom";
import {getAccessToken, getSecondaryInfo, verifyToken} from "@/api/face";
import './index.scss';

const RemoteFace = memo(() => {
  // 使用useLocation钩子获取当前位置对象
  const location = useLocation();

  // 获取查询参数
  const searchParams = new URLSearchParams(location.search);

  const encrypted = searchParams.get('encrypted'); // 假设你想获取名为'param'的查询参数
  const type = searchParams.get('type'); // 假设你想获取名为'param'的查询参数

  const timer = useRef<any>();
  // 是否过期
  const [isExpire, setIsExpire] = useState(false);
  const [info, setInfo] = useState<{
    firmName: string,
    expiration: number,
    operName: string,
    pactName: string
  }>();

  function secondsToTime(seconds: number) {
    const hours = Math.floor(seconds / 3600); // 计算小时数
    const remainingSecondsAfterHours  = seconds % 3600; // 计算剩余秒数
    const minutes = Math.floor(remainingSecondsAfterHours  / 60); // 计算分钟数
    const remainingSeconds = remainingSecondsAfterHours % 60; // 计算剩余秒数

    return `${hours}时${minutes}分${remainingSeconds}秒`
  }


  const fetchSecondaryInfo = async () => {
    try {
      if (encrypted) {
        Toast.show({
          icon: 'loading',
          content: '正在获取数据...',
        });
        console.log(decodeURIComponent('5OAVNkKa1igTshfW7hYInJRPSkHALYcAj%2FN%2BpbfHSzT81szkYaKmzxqVgkxcZJk5zUTorTrj1i7rbDAgi2K0dA%3D%3D'))
        const res = await getSecondaryInfo({
          type,
          encrypted: encrypted.replace(/ /g, '+') // 将空格转回 +
        });
        if (res?.code == 500) {
          setIsExpire(true);
          return;
        }
        setInfo(res);
        if (res.expiration) {
          setIsExpire(false);
        }
        Toast.clear();
      }
    } catch (err) {
      Toast.clear();
      setIsExpire(true);
      console.error(err);
    }
  }

  const fetchAccessToken = async () => {
    try {
      Toast.show({
        icon: 'loading',
        content: '即将进入人脸识别...',
      });

      const res = await getAccessToken();

      const { access_token } = res;

      const verifyResult = await verifyToken(access_token);

      const {success, result} = verifyResult;
      if (success) {
        const { verify_token } = result
        const successPage = encodeURIComponent(window.location.origin + '/faceResult?access_token=' + access_token + '&verify_token=' + verify_token + '&encrypted=' + encrypted + '&type=' + type)
        // const FailPage = encodeURIComponent(window.location.origin + '/faceResult?access_token=' + access_token+ '&encrypted=' + encrypted)
        window.location.href = `https://brain.baidu.com/face/print/?token=${verify_token}&successUrl=${successPage}&failedUrl=${successPage}`
      }
    } catch (err) {
      console.log('访问失败', err);
      console.error(err)
    }
  }

  useEffect(() => {
    fetchSecondaryInfo();
  }, []);

  return (
      <>
        {
          isExpire ? (
              <div style={{ width: '100%', height: '50px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                当前链接已失效...
              </div>
          ) : (
              <div className='remote-face'>
                <div className='remote-face-header'>
                  远程人脸协助
                </div>

                <div className='remote-face-body'>
                  <div className='remote-face-body-cover'>
                    <img src="https://can-open-resource-shenzhenhxjf.oss-cn-shenzhen.aliyuncs.com/public/24e7184e5e94c6989897d78d23e8d0bb.jpg" alt=""/>
                  </div>

                  {
                    type === 'CONFIRM_CONTRACT' ? (
                        <div>
                          贵单位<span className='firmName'>{info?.firmName}</span>已与厦门海峡金融服务有限公司签订《{info?.pactName}》，文件内容请登录海峡金小程中查看。如贵单位已对内容确认无误，请贵单位法人代表({info?.operName})通过"人脸校验”方式完成签收。
                        </div>
                    ) : (
                        <div>
                          贵单位<span className='firmName'>{info?.firmName}</span>正在进行海峡金企业认证，请贵单位法人代表({info?.operName})通过“人脸校验”方式完成此次认证。
                        </div>
                    )
                  }

                  <div
                      className='face-btn'
                      onClick={() => {
                        fetchAccessToken();
                      }}
                  >
                    我是法人, 现在人脸
                  </div>
                </div>
              </div>
          )
        }
      </>
  )
});

export default RemoteFace